import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonCard} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import axiosInstance from '../services/AxiosInstance';
import {CircularProgressbarWithChildren, buildStyles} from 'react-circular-progressbar';
import './css/general.css';
import styles from './css/ChallengeResult.module.css';

interface ResultProps extends RouteComponentProps {
    // Define the props here
  }
  
  interface ResultState {
    // Define the state here

    // Quiz Questions
    questions: Quiz[],
    totalQuizScore: number,
    amountOfQuestions: number,
    totalScoreInPercentage: number,
    correctAnswers: string[],

    // Mood Questions
    moods: Mood[],
    totalMoodScore: number,
    averageMoodScore : number,

    level: number,
  }

  interface QuizInterface{
    question: string,
    questionId: number,
    givenAnswer: string,
    correct: boolean,
    hasImage: boolean,
    imageUrl: string
  }

  class Quiz implements QuizInterface {
    question: string;
    questionId: number;
    givenAnswer: string;
    correct: boolean;
    hasImage: boolean;
    imageUrl: string

    constructor(question: string, questionId: number, givenAnswer: string, correct: boolean, hasImage: boolean,imageUrl: string){
        this.question = question;
        this.questionId = questionId;
        this.givenAnswer = givenAnswer;
        this.correct = correct;
        this.hasImage = hasImage;
        this.imageUrl = imageUrl

    }
  }

  interface MoodInterface{
    moodQuestion: string,
    moodQuestionId: number,
    mood: string,
    moodScore : number
  }

  class Mood implements MoodInterface {
    moodQuestion: string;
    moodQuestionId: number;
    mood: string;
    moodScore : number

    constructor(moodQuestion: string, moodQuestionId: number, mood: string, moodScore : number){
        this.moodQuestion = moodQuestion;
        this.moodQuestionId = moodQuestionId;
        this.mood = mood;
        this.moodScore = moodScore
    }
  }

  class ChallengeResult extends React.Component<ResultProps, ResultState> {
    constructor(props: ResultProps) {
      super(props);
  
      this.state = {
        questions: [{
          question: "",
          questionId: 0,
          givenAnswer: "",
          correct: false,
          hasImage: false,
          imageUrl: ""
        }],
        totalQuizScore: 0,
        amountOfQuestions: 0,
        totalScoreInPercentage: 0,
        correctAnswers: [],
        
        
        moods: [{
            moodQuestion: "",
            moodQuestionId: 0,
            mood: "",
            moodScore : 0
          }],
          totalMoodScore : 0,
          averageMoodScore : 0,


          level: 0
      };

        this.getLevel()
    }

    async getLevel(){
      var id = localStorage.getItem("id");
      var token = localStorage.getItem("token");
  
      let challengesDone: number = 0
  
    axiosInstance
    .get(
        "/Results/Employee/" + id,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
    .then((res) => {
        res.data.forEach((quiz: any) => {
          if(quiz.score >= 0) {
            challengesDone ++
          }
      });
      let level:number = 1
      let challengesForNextLevel:number[] = [3,4,3,2]
      let challengesToDo = challengesForNextLevel[0]
      let index: number = 0
      
      while(challengesDone >= challengesToDo) {
         challengesDone -= challengesToDo;
         level ++;
         if(index % 2 == 0) {
             challengesForNextLevel.push(3)
         } else {
             challengesForNextLevel.push(2)
         }
         index ++
         challengesToDo = challengesForNextLevel[index]
      }

      this.setState({level: level})

      this.getQuizScore()
      })
    }

    async getQuizScore(){
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");
        
        let score = Number(localStorage.getItem("challengeScore"));
        let amountOfQuestions = Number(localStorage.getItem("amountOfQuestions"));

        axiosInstance
        .get( 
            "/SelectedAnswers/Challenge/" + localStorage.getItem("challengeId") + "/User/" + id,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((resp) => {
            //console.log(resp.data)
          resp.data.forEach((i:any)=> {
            if(i.question.fileName == null){
              this.state.questions.push({
                question: i.answer.question.questionText,
                questionId: i.answer.questionId,
                givenAnswer: i.answer.possibleAnswer,
                correct: i.answer.correctAnswer,
                hasImage: false,
                imageUrl: ""
              })
            } else {
              this.state.questions.push({
                question: i.answer.question.questionText,
                questionId: i.answer.questionId,
                givenAnswer: i.answer.possibleAnswer,
                correct: i.answer.correctAnswer,
                hasImage: true,
                imageUrl: i.question.url
              })
            }
          })
          this.state.questions.splice(0, 1);
          let total = Math.round((score/amountOfQuestions) * 100)
          this.setState({questions: this.state.questions, totalQuizScore: score, amountOfQuestions: amountOfQuestions, totalScoreInPercentage: total})

          if(this.state.level >= 3) {
            this.getCorrectAnswers()
          }
        })
        
    }

    async getCorrectAnswers(){
      var id = localStorage.getItem("id");
      var token = localStorage.getItem("token");

      for(const q of this.state.questions){
        //console.log(q)
        await axiosInstance
        .get("/QuestionAnswers/Answers/" + q.questionId, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token
          },
        })
        .then((resp) => {
          //console.log(resp.data)
          resp.data.forEach((ans: any) => {
           if(ans.correctAnswer) {
             //console.log(ans)
            this.state.correctAnswers.push(ans.possibleAnswer)
           }
          })
          this.setState({correctAnswers: this.state.correctAnswers})
        })
      }
      
      if(this.state.level >= 4) {
        this.getMoods()
      }
    }

    async getMoods(){
        var id = localStorage.getItem("id");
        var token = localStorage.getItem("token");

        axiosInstance
        .get(
            "/Moods/user/" + id,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          )
        .then((res) => {
          //console.log(res.data)
            let score = 0
            let totalScore = 0
            res.data.forEach((e:any) => {
                if(e.challengeId == localStorage.getItem("challengeId")){
                  switch(e.employeeMood){
                    case "InLove":
                        totalScore += 100;
                        score = 100;
                        break;
        
                    case "Easy":
                        totalScore += 90;
                        score = 90;
                        break;
        
                    case "Funny":
                        totalScore += 80;
                        score = 80;
                        break;
        
                    case "Good":
                        totalScore += 70;
                        score = 70;
                        break;
        
                    case "OK":
                        totalScore += 60;
                        score = 60;
                        break;
        
                    case "Neutral":
                        totalScore += 50;
                        score = 50;
                        break;
        
                    case "Surprised":
                        totalScore += 40;
                        score = 40;
                        break;
        
                    case "Angry":
                        totalScore += 30;
                        score = 30;
                        break;
        
                    case "Sad":
                        totalScore += 20;
                        score = 20;
                        break;
        
                    case "VerySad":
                        totalScore += 10;
                        score = 10;
                        break;
          
                    case "Sick":
                        totalScore += 0;
                        score = 0;
                        break;
          
                    default:
                        totalScore += 50;
                        score = 50;
                        break;
                };
                    this.state.moods.push({
                      moodQuestion: e.moodQuestion.question,
                      moodQuestionId : e.moodQuestionId,
                      mood: e.employeeMood,
                      moodScore: score
                    })
                }
            });
            this.state.moods.splice(0, 1);
            // Moodquestions altijd op zelfde volgorde
            this.state.moods.sort(function(a, b){return a.moodQuestionId - b.moodQuestionId});

            // Gemiddelde score
            let average = Math.round(totalScore / this.state.moods.length)

            //console.log(this.state.moods)
            this.setState({moods: this.state.moods, totalMoodScore: totalScore, averageMoodScore: average});
          });
    }



    render(){
    let quizScoreColor;
      if(this.state.totalScoreInPercentage < 50) {
        quizScoreColor = "#FF0000"
      } else if (this.state.totalScoreInPercentage > 50) {
        quizScoreColor = "#2dd36f"
      } else {
        quizScoreColor = "#FFA500"
      }

      

      let level2;
      if(this.state.level >= 2) {

        let answerColor: string[] = [];
        this.state.questions.forEach((ans) => {
          if(ans.correct){
            answerColor.push("#2dd36f")
          } else {
            answerColor.push("#FF0000");
          }
        })

        let quiz = this.state.questions.map((q:any, index:number) => (
          <div key= {q.questionId} className = {styles.questions}>
            <p className = {styles.question}>{q.question}</p>
            {q.hasImage && <img className={styles.image} src={q.imageUrl} alt=""/>}
            <p className = {styles.answer} style = {{color: answerColor[index]}}>{q.givenAnswer} </p>
          </div>
        ))

        level2 = 
        <IonCard className={styles.panel}>
          <h1 className={styles.title}>Overzicht quizvragen</h1>
          {quiz}
        </IonCard>
      } else{
        level2 = 
        <IonCard className={`${styles.panel} ${styles.disabledPanel}`}>
        <h1 className={styles.title}>Overzicht quizvragen</h1>
        <p className={styles.text}>Om je antwoorden te kunnen zien moet, je minstens level 2 zijn</p>
        </IonCard>
      }


      let level3;
      if(this.state.level >= 3){
        let qA = this.state.questions.map((q:any, i:number) => (
          <tr key= {q.questionId}>
            <td>
              <p>{q.question}</p> 
              {q.hasImage && <img src={q.imageUrl} alt=""/>}
            </td>
            <td>{this.state.correctAnswers[i]}</td>
          </tr>
        ))
        level3 = 
        <IonCard className={styles.panel}>
          <h1 className={styles.title}>Juiste antwoorden</h1>
          <table>
            <thead>
              <tr>
                <th>Vraag</th>
                <th>Antwoord</th>
              </tr>
            </thead>
            <tbody>
              {qA}
            </tbody>
          </table>
        </IonCard>
      } else {
        level3 = 
        <IonCard className={`${styles.panel} ${styles.disabledPanel}`}>
        <h1 className={styles.title}>Juiste antwoorden</h1>
        <p className={styles.text}>Om de juiste antwoorden te kunnen zien, moet je minstens level 3 zijn</p>
        </IonCard>
      }
     

      let level4;

      if(this.state.level >= 4){

        let moodScoreColor;
        if(this.state.averageMoodScore < 50) {
          moodScoreColor = "#FF0000"
        } else if (this.state.averageMoodScore > 50) {
          moodScoreColor = "#2dd36f"
        } else {
          moodScoreColor = "#FFA500"
        }
  
        let generalMood;
        if(this.state.averageMoodScore <= 40) {
          generalMood = require('../assets/emojis/Sad.png')
        } else if (this.state.averageMoodScore > 40 && this.state.averageMoodScore <= 60) {
          generalMood = require('../assets/emojis/Neutral.png')
        } else if(this.state.averageMoodScore > 60 && this.state.averageMoodScore <= 75){
          generalMood = require('../assets/emojis/OK.png')
        } else if(this.state.averageMoodScore > 75){
          generalMood = require('../assets/emojis/Good.png')
        } else {
          generalMood = require('../assets/emojis/Neutral.png')
        }

        level4 =
        <IonCard className={(styles.panel)}>
        <h1 className={(styles.title)}>Algemene mood tijdens quiz</h1>
        <div className={(styles.graph)} style={{ width: 200, height: 200 }}>
                <CircularProgressbarWithChildren 
                value={this.state.averageMoodScore}
                styles={buildStyles({
                    pathColor: `${moodScoreColor}`,
                    strokeLinecap: 'round',
                    pathTransition: 'stroke-dashoffset 0.5s ease 0s',
                    rotation: 0.5,
                })}>
                    <img src={generalMood} alt="algemene mood" className={(styles.generalMood)}/>
                </CircularProgressbarWithChildren>
            </div>
        </IonCard>
      } else{
        level4 =
      <IonCard className={`${styles.panel} ${styles.disabledPanel}`}>
        <h1 className={styles.title}>Algemene mood tijdens quiz</h1>
        <p className={styles.text}>Om je algemene mood tijdens de quiz te zien, moet je minstens level 4 zijn</p>
      </IonCard>
      };

      let level5;
      if(this.state.level >= 5){
        if(this.state.moods.length > 1){
            let moodQuestions = this.state.moods.map((q:any) => (
              <div key= {q.moodQuestionId} className = {styles.questions}>
                <p className = {styles.question}>{q.moodQuestion}</p>
                <img className={styles.emoji} src={require(`../assets/emojis/${q.mood}.png`)} alt={q.mood}/>
              </div>
            ))
            level5=
          <IonCard className={styles.panel}>
            <h1 className={styles.title}>Overzicht emotionele vragen</h1>
            {moodQuestions}
          </IonCard>
        } 
      } else {
        level5=
        <IonCard className={`${styles.panel} ${styles.disabledPanel}`}>
        <h1 className={styles.title}>Overzicht emotionele vragen</h1>
        <p className={styles.text}>Om je antwoorden op de emotionele vragen te kunnen zien, moet je minstens level 5 zijn</p>
      </IonCard>
       }

      
        return(
            <IonPage>
                <IonHeader class="ion-no-border">
                    <IonToolbar>
                    <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
                        <IonTitle>{localStorage.getItem("challengeTitle")}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen>
                    <div className={styles.overview}>
                      <IonCard className={styles.panel}>
                          <h1 className={styles.title}>Score</h1>
                          <div className={(styles.graph)} style={{ width: 200, height: 200 }}>
                              <CircularProgressbarWithChildren 
                              value={this.state.totalScoreInPercentage}
                              styles={buildStyles({
                                  pathColor: `${quizScoreColor}`,
                                  strokeLinecap: 'round',
                                  pathTransition: 'stroke-dashoffset 0.5s ease 0s',
                                  rotation: 0.5,
                              })}>
                              <p style = {{color: quizScoreColor}} className = {(styles.score)}>{this.state.totalScoreInPercentage}%</p>
                              </CircularProgressbarWithChildren>
                          </div>
                      </IonCard>
                      {level2}
                      {level3}
                      {level4}
                      {level5}
                    </div>
              </IonContent>
            </IonPage>
        );
    }
};

export default withRouter(ChallengeResult);
